import apiClient from "./apiClient";
import { Shift } from "common/models";

const addShift = async (shift: Shift) => {
  return apiClient.post(`/shifts`, shift);
};

const updateShift = async (shift: Shift) => {
  return apiClient.put(`/shifts`, shift);
};

const deleteShift = async (id: number) => {
  return apiClient.remove(`/shifts/${id}`);
};
const shiftsService = {
  deleteShift,
  addShift,
  updateShift,
};

export default shiftsService;
